const { default: ApiService } = require("./api.service");

const DoctorCalendarService = {
    // Ottenere tutte le disponibilità per un intervallo di date
    // Passa l'ID utente (non l'ID terapeuta)
    getAvailabilities: (userId, startDate, endDate) =>
        ApiService.fetch(`therapist/${userId}/availability?start_date=${startDate}&end_date=${endDate}`),

    // Creare una nuova disponibilità
    // Nota: therapistId è in realtà l'ID utente, non l'ID terapeuta
    createAvailability: (availabilityData) =>
        ApiService.fetch('therapist/availability', {
            method: 'POST',
            body: JSON.stringify(availabilityData)
        }),

    // Aggiornare una disponibilità esistente
    updateAvailability: (availabilityId, updatedData) =>
        ApiService.fetch(`therapist/availability/${availabilityId}`, {
            method: 'PUT',
            body: JSON.stringify(updatedData)
        }),

    // Eliminare una disponibilità
    deleteAvailability: (availabilityId) =>
        ApiService.fetch(`therapist/availability/${availabilityId}`, {
            method: 'DELETE'
        }),

    getAppointments: (userId, startDate, endDate) =>
        ApiService.fetch(`therapist/${userId}/appointments?start_date=${startDate}&end_date=${endDate}`),

    // Impostare un'eccezione (giorno non disponibile)
    // Nota: nelle exceptionData, therapist_id è in realtà l'ID utente
    setException: (exceptionData) =>
        ApiService.fetch('therapist/availability/exception', {
            method: 'POST',
            body: JSON.stringify(exceptionData)
        }),

};

export default DoctorCalendarService;